module.exports = require("element-ui/lib/transitions/collapse-transition");